import { CalendarTimesModel } from '../models/calendar_times_model';
import { IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';

export type ClearCalendarSectionTimesCommand = () => ng.IPromise<IQuery>;

angular
  .module('capability-ng-scheduler')
  .service(
    'clearCalendarSectionTimesCommand',
    (defineCommandORM: IDefineCommand, ngCalendarTimesModel: CalendarTimesModel) => {
      return defineCommandORM('clearCalendarSectionTimesCommand', (deferred) => {
        const calendarSnapshot = ngCalendarTimesModel.read();
        ngCalendarTimesModel.clear().write({
          ...calendarSnapshot,
          section_times: []
        });
        deferred.resolve();
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/calendar/commands/clear_calendar_section_times_command.ts